import React from "react";

const TablaSeleccioneMedicoCirugiaMEDICO = ({item,passDataMedico,dataUserMedico,dataUser}) => {
  const dataMedico={
    MedCod:item.MedCod,
    MMNomM:item.MMNomM,
    MECodE:item.MECodE
  }
  const handleOnclickMedico=()=>{
    passDataMedico(dataMedico)
  }
  return (
    <tr className={(dataUserMedico.Codigo_medico === item.MedCod && '4' === dataUser.ProEsta)?"divide-y divide-slate-700 bg-[#a7f3d0]":"divide-y divide-slate-700 "}>
      <td></td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">
        <button
          onClick={handleOnclickMedico}
          type="button"
          className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
        >
          Seleccionar
        </button>
      </td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap">
      {item.MedCod}
      </td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">
      {item.MMNomM}
      </td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap ">
      {item.MECodE}
      </td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">
      {item.MENomE}
      </td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap ">
      {item.PRCODI}
      </td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">
      {item.PrNomb}
      </td>
      
    </tr>
  );
};

export default TablaSeleccioneMedicoCirugiaMEDICO;
